import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ViewChildren,
  QueryList,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OfferDetailsComponent } from 'src/app/pages/offer-management/create-offer/offer-details/offer-details.component';
import { EventProvider } from 'src/app/services/event';
import { ObservationEvents } from 'src/app/utilities/constant';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent implements OnInit, AfterViewInit {
  @Input() steps: any[] = [];
  @Output() stepDetail = new EventEmitter<string>();
  @Output() steper = new EventEmitter<string>();
  @Output() navBack = new EventEmitter<string>();
  @Input() currentStep: string;
  @Input() isToggleAllowed: boolean = true;
  @Input() showCompletedSteps: boolean = false;
  @ViewChild('offerDetailsRef') offerDetailsCmpnt: OfferDetailsComponent;
  @Input() isStepComplited = false;
  @Input() isVertical = false;
  @ViewChildren('stepElement') stepElements: QueryList<ElementRef>;
  @ViewChild('stepperContainer') stepperContainer: ElementRef;
  private isValidToToggle = false;
  constructor(
    public eventProvider: EventProvider,
    public translate: TranslateService,
  ) {}

  ngOnInit() {
    this.eventProvider
      .event(ObservationEvents.STEPPER_TYPE)
      .subscribe((res) => {
        this.syncActiveStep(res);
      });
  }

  ngAfterViewInit() {
    this.scrollToActiveStep();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.currentStep || changes.steps) {
      this.syncActiveStep(this.currentStep);
    }
  }

  private syncActiveStep(activeStep: string) {
    if (!this.steps?.length) {
      return;
    }

    const activeIndex = this.steps.findIndex((step) => {
      return step.val === activeStep ||
        step.key === activeStep ||
        step.title === activeStep ||
        step.name === activeStep;
    });

    this.steps.forEach((step, index) => {
      step.isCurrent = index === activeIndex;
      step.isActive = this.showCompletedSteps
        ? !!step.isdone || (index === activeIndex && !step.isPartial)
        : activeIndex >= 0 ? index <= activeIndex : index === 0;
    });

    this.scrollToActiveStep();
  }

  /**
   * Scrolls the active step into view for horizontal steppers.
   * This keeps the current step visible after state updates.
   */
  private scrollToActiveStep() {
    // Only auto-scroll in horizontal mode, once refs are available.
    if (!this.isVertical && this.stepperContainer && this.stepElements) {
      // Delay ensures DOM/classes are updated before querying active element.
      setTimeout(() => {
        const activeStep = this.stepElements.find((el) => {
          return el.nativeElement.classList.contains('active');
        });

        // Smoothly center the active step in the horizontal viewport.
        if (activeStep) {
          activeStep.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
          });
        }
      }, 150);
    }
  }

  /**
   * Toggles step
   *
   * @param index index
   * @param stepData stepData
   */
  public toggleStep(index: number, stepData: string) {
    if (this.isToggleAllowed) {
      this.eventProvider
        .event(ObservationEvents.OFFER_DETAIL_FORM_VALIDITY)
        .subscribe((isValid) => {
          this.isValidToToggle = isValid;
        });
      this.stepDetail.emit(stepData);
      this.steps.forEach((step, i) => {
        if (this.isValidToToggle) {
          step.isCurrent = i === index;
          step.isActive = this.showCompletedSteps
            ? !!step.isdone || (i === index && !step.isPartial)
            : i <= index;
        }
      });
      this.scrollToActiveStep();
    }
  }
}
